import { Text } from "@marketplace/ui";

export const SellerStatusBadge = ({ status }: { status?: string }) => {
  if (!status) {
    return null;
  }

  const isVerified = status === "active";

  return (
    <div
      className={`px-[6px] py-1 rounded text-center max-w-[100px] ${
        isVerified
          ? "bg-[#E5FFDE] text-[#45B527]"
          : "bg-[#FFE7E7] text-[#8B1515]"
      }`}
    >
      <Text>{isVerified ? "Verified" : "Unverified"}</Text>
    </div>
  );
};
